import coreStore from './core-store'
import Vue from "vue";
import Axios from 'axios'

const remoteResource = 'payment/api/v1/payment-batches';

const store = coreStore.createCoreStore('paymentBatch', remoteResource, 'paymentBatches');

store.state.activePaymentBatch = null

store.mutations.setActivePaymentBatch = (state, newPaymentBatch) => state.activePaymentBatch = newPaymentBatch;

store.state.paymentsByBatch = {}

store.getters.paymentsByBatch = (state) => (batchId) => state.paymentsByBatch[batchId]

store.mutations.setPaymentsByBatch = function(state, {batchId, payments}) {
    Vue.set(state.paymentsByBatch, batchId, payments);
}

store.actions.processWorkflow = function({commit}, {batchId, action, user}) {
    return Axios.post(`${remoteResource}/${batchId}/${action}`, {paymentBatchId: batchId, message: `${action} by ${user}`, userId: user});
}

store.actions.loadPaymentsByBatch = function({commit}, {batchId}) {
    return Axios.get(`${remoteResource}/${batchId}/payments`)
        .then(
            res => {
                commit('setPaymentsByBatch', {batchId, payments: res.data})
            }
        )
}


export default store;